<ng-container *transloco="let t; read: 'user'">
@if (!isStateDashboardEnabled) {
  <div class="bg-drdpblue-200 px-5">
    <div class="min-w-full flex place-content-between place-items-center">
      <drdp-title class="mt-4" [title]="t('dashboard.welcome')"> {{ user.userName }}</drdp-title>
      @if (canViewPortfolioMessages) {
        <img
          class="cursor-pointer"
          [src]="icon"
          [alt]="t('dashboard.messageBoardAlt')"
          routerLink="/portfolio-messages"
        />
      }
    </div>
    <div>
      <mat-checkbox [checked]="isSignedUp" (change)="onCheckboxChange()">
        <span
          >{{ t('dashboard.weeklyUpdatesOptIn') }}</span
        >
      </mat-checkbox>
    </div>
    <div>
      @if (canViewNewsItem) {
        <div>
          @for (announcement of announcements; track announcement) {
            <div class="p-6 bg-white rounded-[30px] shadow-md mt-5">
              <div
                class="flex flex-col sm:flex-row sm:justify-between mb-4 gap-y-4"
              >
                <span class="text-[16px] text-lg-300 font-semibold text-center">
                  @if (announcement.icon) {
                    <i
                      [ngClass]="[
                        'uis',
                        'uis-' + announcement.icon,
                        'mr-2',
                        'text-2xl',
                      ]"
                    ></i>
                  }
                  <!-- Server-supplied copy: localized by the API, not by Transloco. -->
                  {{ announcement.message }}
                </span>
                <drdp-pill pillClass="Announcement"> {{ t('dashboard.announcementPill') }} </drdp-pill>
              </div>
            </div>
          }
          <drdp-news-item class="flex place-content-between"></drdp-news-item>
        </div>
      }
      <h2 class="text-[20px] font-bold mt-5 mb-4">{{ t('dashboard.myDashboard') }}</h2>
      <div class="grid lg:grid-cols-4 md:grid-cols-3 gap-4">
        @if (canViewLockedChildren) {
          <drdp-container color="whiteDash" additionClasses="justify-center">
            <a
              class="flex-col text-center px-4 pb-4 h-36"
              [routerLink]="['/total-locked-children']"
            >
              <p class="text-drdpblue-300 text-[60px]">
                {{ ratingCount }}
              </p>
              <p class="text-[15px]">{{ t('dashboard.totalLockedChildren') }}</p>
            </a>
          </drdp-container>
        }
        @for (info of myDashboard; track info) {
          <drdp-container
            *drdpCheckPermission="info.access"
            color="whiteDash"
            additionClasses="justify-center"
          >
            <a
              class="grid grid-cols-1 text-center p-4 w-full h-36"
              [routerLink]="[info.link]"
            >
              @if (info.hasPendingRequest) {
                <div class="flex justify-end">
                  <div
                    class="rounded-full py-1 bg-drdpblue-300 text-white text-xs w-24"
                  >
                    {{ t('dashboard.itemsPending') }}
                  </div>
                </div>
              }
              @if (info.icon) {
                <i
                  class="text-drdpblue-300 text-[60px] {{
                    info.icon
                  }} flex justify-center"
                ></i>
              }
              <p class="text-[15px] flex justify-center">{{ info.label }}</p>
            </a>
          </drdp-container>
        }
      </div>
      @if (canViewLanguage || canEditLanguage) {
        <div>
          <h2 class="text-[20px] font-bold mt-5 mb-2">{{ t('dashboard.languageSettings') }}</h2>
          <div class="flex flex-row">
            <div
              class="basis-full md:basis-1/2 bg-white rounded-[30px] shadow-md px-5 pt-4 pb-3"
            >
              @for (info of languageSettingsInfo; track info) {
                <div class="mb-1">
                  <mat-slide-toggle
                    [disabled]="!canEditLanguage"
                    color="primary"
                    (change)="toggleSwitchAction(info.label)"
                  >
                  </mat-slide-toggle>
                  <span> {{ info.label }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <drdp-state-dashboard></drdp-state-dashboard>
}
</ng-container>
